import { onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { getAuthentication } from 'shared/services/backend-api/helpers/auth';

// Firebase Auth session presence, undefined until the SDK restored it. Reads no query, so it never suspends.
export const useIsSignedIn = (): boolean | undefined => {
  const [isSignedIn, setIsSignedIn] = useState<boolean | undefined>();

  useEffect(() => {
    let active = true;
    let unsubscribe: (() => void) | undefined;
    const subscribe = async () => {
      const auth = await getAuthentication();
      if (!active) {
        return;
      }
      unsubscribe = onAuthStateChanged(auth, (user) => setIsSignedIn(!!user));
    };
    subscribe();

    return () => {
      active = false;
      unsubscribe?.();
    };
  }, []);

  return isSignedIn;
};
